<template lang="html">
    <div class="hydrologic-variability-period-legend">
        <div
            class="columns"
        >
            <div
                v-for="(periodData, key, i) in data"
                :key="key"
                class="column"
            >
                <div
                    class="is-flex legend-item"
                    :class="`period-${i}`"
                >
                    <span class="legend-text">{{ key }}</span>
                    <div class="legend-icon" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.hydrologic-variability-period-legend {
    .legend-item {
        justify-content: center;

        .legend-text {
            margin-right: 0.5rem;
            line-height: 1rem;
        }

        .legend-icon {
            height: 1rem;
            width: 1rem;
            border: 1px solid black;
            border-radius: 0.25rem;
        }

        &.period-0 .legend-icon { background-color: $color-hydrovar-1; }
        &.period-1 .legend-icon { background-color: $color-hydrovar-2; }
        &.period-2 .legend-icon { background-color: $color-hydrovar-3; }
        &.period-3 .legend-icon { background-color: $color-hydrovar-4; }
    }
}
</style>
